<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red" style="height: 1rem">
      <div class="picTxt acea-row row-between-wrapper" style="height: 1rem;display: block;">
        <div style="text-align: center">
          <p
            style="line-height: 1rem;font-size: 0.4rem;font-weight:600;color: #fff"
            v-if="type == 0"
          >劵详情信息</p>
          <p style="line-height: 1rem;font-size: 0.4rem;font-weight:600;color: #fff" v-else>转赠劵</p>
        </div>
      </div>
    </div>
    <div style="height: 0.2rem;"></div>
    <div class="list" id="posterHtml" ref="haibao" v-if="posterImage == null">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">{{ order.title }}</div>
          <div v-if="type == 0">
            <div class="font-color-red" v-if="order.status == 0">未使用</div>
            <div class="font-color-red" v-if="order.status == 1">已使用</div>
            <div class="font-color-red" v-if="order.status == 2">已转赠</div>
            <div class="font-color-red" v-if="order.status == 3">已过期</div>
          </div>
        </div>

        <div>
          <div class="item-info acea-row row-between row-top" v-if="type == 0">
            <div class="pictrue">
              <img :src="order.img" />
            </div>

            <div class="text acea-row row-between">
              <div class="name line2">{{ order.store_name }} {{ order.store_info }}</div>
            </div>
          </div>
        </div>
        <div style="height: 0.2rem;"></div>

        <div style="margin: 0 auto;display: table;" v-if="type == 0">
          <VueBarcode
            :value="order.unique_id"
            :options="barcode_option"
            tag="svg"
            style="width: 100%"
            v-if="order.status==0"
          ></VueBarcode>
        </div>

        <div style="margin: 0 auto;display: table;" v-if="type == 1">
          <ExchangeCode
            v-on:setPosterImageStatus="setPosterImageStatus"
            :posterImageStatus="posterImageStatus"
            :posterData="posterData"
          ></ExchangeCode>
        </div>

        <div class="totalPrice">
          订单号：{{ order.order_id }}
          <br />
          到期时间：{{ order.coupons_time2 }}
        </div>
      </div>
    </div>

    <div class="list" style="margin: 0 auto;display: table;" v-if="posterImage != null">
      <img style="width: 100%" :src="posterImage" alt="123456" />
    </div>

    <div
      class="keep"
      style="text-align: center;
    line-height: 1rem;"
      v-if="posterImage != null"
    >长按图片可以保存到手机或发送给朋友</div>
  </div>
</template>


<script>
import { getCardbagDetails } from "@api/coupons";
import VueBarcode from "@xkeshi/vue-barcode"; //条形码
import ExchangeCode from "@components/qrcode"; //二维码海报
import { imageBase64 } from "@api/public";
import { cancelOrderHandle, takeOrderHandle } from "@libs/order";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import html2canvas from "html2canvas";

const NAME = "CardbagDetails";

export default {
  name: NAME,
  data() {
    return {
      reFresh: true,
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      loading: false,
      orderList: [],
      cid: this.$route.params.cid || 0,
      //条形码
      barcode_option: {
        displayValue: true, //是否默认显示条形码数据
        //textPosition  :'top', //条形码数据显示的位置
        background: "#fff", //条形码背景颜色
        valid: function(valid) {
          console.log(valid);
        },
        width: "2px",
        height: "55px",
        fontSize: "22px" //字体大小
      },
      //二维码
      posterImageStatus: false,
      posterData: {
        image: "",
        title: "",
        price: "",
        code: ""
      },
      canvasStatus: false,
      posterImage: null
    };
  },
  components: {
    //组件注册
    VueBarcode,
    ExchangeCode
  },

  watch: {
    //检测路由改变
    $route(n) {
      if (n.name === NAME) {
        const cid = this.$route.params.cid || 0;
        const type = this.$route.params.type || 0;
        if (this.cid !== cid || this.type !== type) {
          this.reFresh = false;
          this.changeorder(cid, type);
          this.reFresh = true;
        }
      }
    }
  },

  methods: {
    //函数定义

    /**
     * 获取兑换核销码信息
     */
    getCardbagDetails() {
      let that = this;
      const { cid, type } = this;
      getCardbagDetails({ cid, type }).then(res => {
        console.log(res.data);
        this.orderList = this.orderList.concat(res.data);
        this.posterData.image = res.data.img;
        this.posterData.title = res.data.store_name;
        this.posterData.price = res.data.username;
        this.posterData.code = res.data.qrcode;
        if (this.type == 1) {
          that.getImageBase64();
        }
      });
    },

    takeOrder(order) {
      takeOrderHandle(order.order_id).finally(() => {
        this.reload();
        this.getDuihuanLesr();
      });
    },

    reload() {
      this.changeType(this.type);
    },

    changeorder(cid, type) {
      this.cid = cid;
      this.type = type;
      this.orderList = [];
      this.loaded = false;
      this.posterImageStatus = false;
      this.loading = false;
      this.posterImage = null;
      this.canvasStatus = false;
      this.getCardbagDetails();
    },

    //获取状态文字
    getStatus(order) {
      return STATUS[order._status._type];
    },

    getImageBase64: function() {
      let that = this;
      imageBase64(this.posterData.image, that.posterData.code)
        .then(res => {
          that.posterData.image = res.data.image;
          that.posterData.code = res.data.code;
          that.isLogin && that.shareCode();
          that.setPosterImageStatus();
          that.setHtml2Canvas();
        })
        .catch(() => {
          that.isLogin && that.shareCode();
        });
    },

    //二维码
    setPosterImageStatus: function() {
      var sTop = document.body || document.documentElement;
      sTop.posters = 0;
      this.posterImageStatus = !this.posterImageStatus;
      this.posters = false;
    },

    setHtml2Canvas: function() {
      let that = this;
      const canvas = document.createElement("canvas");
      let canvasBox = that.$refs.haibao;
      const width = parseInt(window.getComputedStyle(canvasBox).width);
      const height = parseInt(window.getComputedStyle(canvasBox).height);
      canvas.width = width * 2;
      canvas.height = height * 2;
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      const context = canvas.getContext("2d");
      context.scale(2, 2);
      const options = {
        backgroundColor: null,
        canvas,
        useCORS: true
      };
      setTimeout(function() {
        html2canvas(canvasBox, options).then(function(canvas) {
          that.posterImage = canvas.toDataURL();
          that.canvasStatus = true;
          that.$dialog.loading.close();
        });
      }, 500);
    }
  },

  mounted() {
    //初始化方法
    this.getCardbagDetails(); //获取列表
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
</style>